export const types = [
  'email',
  'required',
  'minLength',
  'maxLength',
  'sameAs',
  'policyNumber',
  'uniqueAccount',
  'dateOfBirth',
  'accountExists',
  'name',
  'validForTerritory',
];

export interface IValidationMessageItem {
  [key: string]: string;
}

export interface IValidationMessages {
  [key: string]: IValidationMessageItem;
}

const messages: IValidationMessages = {
  firstName: {
    required: 'L_firstname_required',
    minLength: 'L_min_length_msg',
    maxLength: 'L_max_length_msg',
    name: 'L_firstname_invalid_msg',
  } as IValidationMessageItem,
  lastName: {
    required: 'L_lastname_required',
    minLength: 'L_lastname_min_length_msg',
    maxLength: 'L_lastname_max_length_msg',
    name: 'L_lastname_invalid_msg',
    accountExists: 'L_lastname_not_exists',
  } as IValidationMessageItem,
  emailAddress: {
    required: 'L_email_required',
    email: 'L_email_valid',
    noSingleQuotes: 'L_email_valid',
    maxLength: 'L_email_max_length',
    uniqueAccount: 'L_email_exist',
  } as IValidationMessageItem,
  selectedOption: {
    required: 'L_must_selection_option',
  } as IValidationMessageItem,
  confirmEmailAddress: {
    required: 'L_confirm_email_required',
    email: 'L_email_valid',
    maxLength: 'L_email_max_length',
    sameAs: 'L_confirm_email_match',
  } as IValidationMessageItem,
  phoneNumber: {
    minLength: 'L_phone_length',
    uniqueAccount: 'L_phone_exist',
  } as IValidationMessageItem,
  fundAccountNumber: {
    required: 'L_fund_account_number_required',
    uniqueAccount: 'L_fund_account_num_exists',
  } as IValidationMessageItem,
  policyNumber: {
    required: 'L_policy_number_required',
    policyNumber: 'L_policy_num_rule',
    policyNumberCanada: 'L_policy_num_canada_rule',
    policyNumberUS: 'L_policy_num_us_rule',
    minLength: 'L_policy_num_min_length',
    uniqueAccount: 'L_policy_num_exist',
    validPolicy: 'L_policy_num_invalid',
  } as IValidationMessageItem,
  socialSecurityNumber: {
    required: 'L_ssn_required',
    uniqueAccount: 'L_ssn_exist',
    accountExists: 'L_ssn_not_exists',
    minLength: 'L_ssn_min_length',
  } as IValidationMessageItem,
  socialInsuranceNumber: {
    required: 'L_sin_required',
    minLength: 'L_sin_min_length',
  } as IValidationMessageItem,
  otpCode: {
    required: 'L_otp_required_field',
    minLength: 'L_otp_code_min_length',
  } as IValidationMessageItem,
  dateOfBirth: {
    required: 'L_date_of_birth_is_required',
    date: 'L_invalid_date',
    noUnder18: 'L_policy_owner_must_be_over_18',
    noPre1900Date: 'L_invalid_date',
  } as IValidationMessageItem,
  generic: {
    invalid: 'L_generic_invalid',
  } as IValidationMessageItem,
  password: {
    required: 'L_password_is_required',
    minLength: '',
    noSpaces: 'L_your_password_cannot_have_spaces',
    noInvalidSpecialChars: 'L_your_password_cannot_contain_certain_special_characters',
    requireUpperLowerCase: '',
    requireNumber: '',
    requireSymbol: '',
    notContainString: 'L_your_password_cannot_contain_your_user_id',
    noThreeCharsInRow: 'L_your_password_cannot_have_three_of_the_same_characters_in_a_row',
    passwordReqContent: 'L_your_password_must_contain_uppder_and_lower_letters_at_least_one_number',
  } as IValidationMessageItem,
  confirmPassword: {
    required: 'L_confirm_password_required',
    sameAs: 'L_confirm_password_match',
  } as IValidationMessageItem,
  territory: {
    required: 'L_territory_required',
    validSelection: 'L_territory_please_select_from_list',
  } as IValidationMessageItem,
  postalCode: {
    required: 'L_postal_code_required',
    minLength: 'L_postal_code_min_length',
    validForTerritory: 'L_postal_code_invalid_for_territory',
  } as IValidationMessageItem,
  zipCode: {
    required: 'L_zip_code_required',
    minLength: 'L_zip_code_min_length',
  } as IValidationMessageItem,
  datepicker: {
    required: 'L_datepicker_required',
    exceeded: 'L_datepicker_value_exceeded',
  } as IValidationMessageItem,
  reason: {
    required: 'L_reason_required',
  } as IValidationMessageItem,
  subject: {
    required: 'L_subject_required',
  } as IValidationMessageItem,
  message: {
    required: 'L_message_required',
  } as IValidationMessageItem,
  allocationPercentage: {
    required: 'L_allocation_percentage_required',
    allocationZeroOrLess: 'L_allocation_percentage_zero_or_less',
    allocationOverHundred: 'L_allocation_percentage_over_hundred',
    invalidCharacter: 'L_allocation_percentage_invalid_character',
  } as IValidationMessageItem,
};

export function getTypes(field: string) {
  if (typeof messages[field] !== 'undefined') {
    return Object.keys(messages[field]);
  }
  return [];
}

export default messages;
